import React from "react";
import Slider from "react-slick";
import { Container, Hidden } from "react-grid-system";
import ContactCTA from "../../components/common/ContactCTA";
import SectionTitle from "../../components/common/SectionTitle";
import { SERVICE_DATA } from "../../constants/serviceData";

const Service = () => {
    const service = SERVICE_DATA;

    let sliderSettings = {
        dots: true,
        speed: 500,
        arrows: false,
        infinite: true,
        initialSlide: 0,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    centerMode: true,
                    centerPadding: 50,
                },
            },
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: 50,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 100,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="section section-service section-service-5">
            <div className="display-spacing mb-0">
                <Container>
                    <SectionTitle label="Service" title="High-quality development, delivered with confidence" align="center" />
                   
                    <Hidden xs sm md>
                    <Slider className="el-slider el-slider-plr--15 mb-30" {...sliderSettings}>
                        {service?.map((item, index) => (
                            // <div className={`banner ${active ? "active" : ""}`}>{children}</div>
                            item.description && 
                            <div className={`service-wrap ${index % 2 ? "itemDevide" : ""}`} key={index}>
                            <hr className={`hr-${index}`}/>
                            <hr className={`h-horizontal-${index}`} />
                                <div className="service-item">
                                    <div className="service-head">
                                        <div className="image-container">
                                        <img src={`/assets/images/service/${item?.iconName}`} alt="iosimage" className={`icon-${index}`}/>
                                        </div>
                                    </div>
                                    <div className="service-body">
                                        {index === 3 ? <h4>{item?.skillName}</h4> : <h3>{item?.skillName}</h3>}
                                        <p dangerouslySetInnerHTML={{__html: item?.description}}></p>
                                    </div>
                                </div>
                            </div>

                        ))}
                    </Slider>
                    </Hidden>

                    <Hidden lg xl>
                    {service?.map((item, index) => (
                            item.description && 
                            <div className={`service-wrap ${index % 2 ? "itemDevide" : ""}`} key={index}>
                            <hr className={`hr-${index}`}/>
                            <hr className={`h-horizontal-${index}`} />
                                <div className="service-item">
                                    <div className="service-head">
                                        <div className="image-container">
                                        <img src={`/assets/images/service/${item?.iconName}`} alt="iosimage" className={`icon-${index}`}/>
                                        </div>
                                    </div>
                                    <div className="service-body">
                                        {index === 3 ? <h4>{item?.skillName}</h4> : <h3>{item?.skillName}</h3>}
                                        <p dangerouslySetInnerHTML={{__html: item?.description}}></p>
                                    </div>
                                </div>
                            </div>

                        ))}
                    </Hidden>
                    <ContactCTA />
                </Container>
            </div>
        </section>
    );
}

export default Service;
